// ======================================================================
// File: src/modules/ppe/components/orders/OrdersTable.jsx
// ======================================================================

import React from "react";
import { useNavigate } from "react-router-dom";

import { SALES_ORDER_STATUS_MAP } from "../../constants/orderStatusMap";

// ----------------------------------------------------------------------
// Status → Bootstrap color mapping (UX only)
// ----------------------------------------------------------------------
function getStatusColor(statusId) {
  switch (statusId) {
    case 1: return "secondary"; // Draft
    case 2: return "primary";   // Released
    case 3: return "warning";   // In Progress
    case 4: return "success";   // Completed
    case 5: return "dark";      // On Hold
    case 6: return "danger";    // Cancelled
    default: return "light";
  }
}

export default function OrdersTable({ rows, loading, hasFilters }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="text-center py-4 text-muted">
        Loading production orders…
      </div>
    );
  }

  if (!loading && rows.length === 0) {
    return (
      <div className="text-center py-4 text-muted">
        {hasFilters
          ? "No production orders found for selected criteria"
          : "No production orders created yet"}
      </div>
    );
  }

  return (
    <table className="table table-hover mt-3">
      <thead className="table-light">
        <tr>
          <th>Order No</th>
          <th>Customer</th>
          <th>Status</th>
          <th>Created At</th>
        </tr>
      </thead>

      <tbody>
        {rows.map((o) => (
          <tr
            key={o.id}
            className="align-middle"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/ppe/orders/${o.id}`)}
          >
            <td>{o.order_number}</td>

            <td>{o.customer_name}</td>

            <td>
              <span
                className={`badge bg-${getStatusColor(o.status_id)}`}
              >
                {SALES_ORDER_STATUS_MAP[o.status_id] || "—"}
              </span>
            </td>

            <td>
              {o.created_at
                ? new Date(o.created_at).toLocaleDateString()
                : "—"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
